export const maskOptions = {
    precision: 0,
    separator: ".",
    delimiter: ",",
    unit: "$",
    suffixUnit: "",
};
export const channelCustomTypes = {
    notifications2: "newNotifications",
    banner: "banner",
    promotions: "promotions",
    salesConcierge: "salesConcierge",
    friends: "friends",
    support: "support",
    announcements: "announcements",
    delivery: "delivery",
    // deprecated
    promotionCarousel: "promotionCarousel",
    marketing: "marketing",
    customerSupportBot: "customerSupportBot",
    netflix: "netflix",
    notifications: "Notifications",
    fakeClosedTicket: "fakeClosedTicket",
};
export const messageCustomTypes = {
    notification: "notification",
    banner: "banner",
    marketing: "marketing",
    splitPayment: "splitPayment",
    support: "support",
    vote: "vote",
    splitCost: "splitCost",
    csat: "csat",
    csat5: "csat5",
    interactiveResponse: "interactiveResponse",
    freeTextResponse: "freeTextResponse",
    orderConfirmation: "orderConfirmation",
    map: "map",
    splitPaymentUpdate: "splitPaymentUpdate",
    couldNotRecognize: "couldNotRecognize",
    callStarted: "callStarted",
    callEnded: "callEnded",
    // deprecated
    promotionCarousel: "promotionCarousel",
    netflix: "netflix",
    paymentResult: "paymentResult",
    warning: "warning",
    bot: "bot",
    notifications: "Notifications",
    keypadVerified: "keypad_verified",
};
export const botUserIds = {
    angela: "tmp-angela",
    daniel: "tmp-daniel",
    grace: "tmp-grace",
    jade: "tmp-jade",
    jaime: "tmp-jaime",
    kim: "tmp-kim",
    robin: "tmp-robin",
    bannerBot: "tmp-banner-bot",
    promotionBot: "tmp-promotion-bot",
    notificationBot: "tmp-notification-bot",
    supportBot: "tmp-support-bot",
    announcementBot: "tmp-announcement-bot",
    deliveryBot: "tmp-delivery-bot",
};
export const BOT_QUESTIONS = {
    first: "I’m here to help with your onboarding. What would you like to know?",
    deposit: "Did the article help? I’m here for any more questions.",
    loan: "Hello {nickname}! You might be interested in our Personal loan. Can I help you with getting started?",
    name: "What is your full name?",
    loanPurpose: "Nice. Let’s move on. What is the purpose of this loan?",
    loanAmount: "How much are you looking to take out?",
    proceed: "Would you like to proceed?",
};
export const INTERACTIVE_CHAT_RESPONSES = {
    first: {
        deposit: "How do I deposit money?",
        withdraw: "How do I withdraw money?",
        card: "How do I create a BirdPay card?",
    },
    deposit: {
        limit: "Is there a limit for deposits?",
        cancel: "How do I cancel deposits?",
        time: "How long does it take for the deposit to process?",
    },
    confirmResolution: {
        resolved: "Thanks, I’m all good now!",
        notResolved: "I need more help. Please connect me with a customer support agent.",
    },
    loan: {
        yes: "👌Yes, I am interested in getting a loan.",
        no: "❌ No, I am not interested.",
    },
    proceed: {
        yes: "Yes, let’s do it!",
        no: "No, I’ll try again next time",
    },
    new: {
        salesConcierge1: {
            en: "Perfect timing! I have a special friend with a birthday later this month.",
            ko: "완벽한 타이밍! 이번 달 말에 생일인 특별한 친구가 있습니다.",
            es: "¡Tiempo perfecto! Tengo un amigo especial con un cumpleaños a finales de este mes.",
        },
        friends1: {
            en: "Can you contribute the money now?",
            ko: "지금 돈을 기부할 수 있습니까?",
            es: "¿Puedes contribuir con el dinero ahora?",
        },
        friends2: {
            en: "It comes to $45 each after taxes and fees.",
            ko: "세금과 수수료를 포함하면 각각 $45입니다.",
            es: "Llega $ 45 cada uno después de impuestos y tarifas.",
        },
        friends3: {
            en: "Thanks team. Grace is going to be so surprised. See you at the party!",
            ko: "감사합니다 팀. 그레이스는 너무 놀랄 것입니다. 파티에서 만나요!",
            es: "Gracias equipo. Grace se sorprenderá. ¡Te veo en la fiesta!",
        },
        support1: {
            en: "I have insufficient funds.",
            ko: "자금이 충분하지 않습니다.",
            es: "Tengo fondos insuficientes.",
        },
        support2: {
            en: "Yes, it solved my problem.",
            ko: "예, 문제가 해결되었습니다.",
            es: "Sí, resolvió mi problema.",
        },
        support3: {
            en: "No, I need to chat with a live agent.",
            ko: "아니요, 라이브 에이전트와 채팅하고 싶습니다.",
            es: "No, necesito chatear con un agente en vivo.",
        },
        support4: {
            en: "Yes, I clicked to split the purchase with my friends.",
            ko: "예, 구매를 친구들과 나누기 위해 클릭했습니다.",
            es: "Sí, hice clic para dividir la compra con mis amigos.",
        },
        support5: {
            en: "A group of friends",
            ko: "친구 그룹",
            es: "Un grupo de amigos",
        },
        support6: {
            en: "Pine Street Friends",
            ko: "파인 스트리트 친구들",
            es: "Amigos de Pine Street",
        },
        support7: {
            en: "Perfect! Thanks so much.",
            ko: "완벽합니다! 정말 고맙습니다.",
            es: "¡Perfecto! Muchas gracias.",
        },
        delivery1: {
            en: "Any update on arrival time?",
            ko: "도착 시간에 대한 업데이트가 있습니까?",
            es: "¿Alguna actualización sobre la hora de llegada?",
        },
        delivery3: {
            en: "The red one",
            ko: "빨간 것",
            es: "El rojo",
        },
        yes: { en: "Yes", ko: "네", es: "Sí" },
        great: { en: "Great", ko: "좋아요", es: "Excelente" },
        thumbsUp: { en: "👍", ko: "👍", es: "👍" },
        no: { en: "No", ko: "아니요", es: "No" },
    },
};
export const products = [
    {
        id: "621785f7-135c-45e1-8a55-cffd9076b988",
        name: "White & Blue Low Vulcanized Sneakers",
        price: "$120",
        url: "https://www.ssense.com/en-ca/men/product/off-white/white-and-blue-low-vulcanized-sneakers/8952741",
    },
    {
        id: "0965c8ba-51d1-4438-bb1e-fd7288c7a2bc",
        name: "NEW BALANCE Green 327 Sneakers",
        price: "$130",
        url: "https://www.ssense.com/en-ca/men/product/new-balance/green-327-sneakers/8467761",
    },
    {
        id: "c12fe9ac-0f8c-4df5-a62a-f4b57188487b",
        name: "Black & Off-White Check Graffiti Kurt High-Top Sneakers",
        price: "$243",
        url: "https://www.ssense.com/en-us/men/product/r13/black-and-off-white-check-graffiti-kurt-high-top-sneakers/9481241",
    },
];
export const PRIMARY_USER_NAME = "Alex";
export const USER_JOURNEY_FLAGS = {
    renewed: "renewed",
    shared: "shared",
    preordered: "preordered",
    splitCost: "splitCost",
};
export const USER_METADATA_KEYS = {
    userJourneyFlags: "userJourneyFlags",
    initData: "initData",
    selectedChocolateBoxKey: "selectedChocolateBoxKey",
    initializedVersion: "initializedVersion",
    language: "language",
    os: "os",
};
export const CHANNEL_METADATA_KEYS = {
    isBotTyping: "isBotTyping",
    state: "state",
    typingUserId: "typingUserId",
};
export const chocolateBoxes = {
    gold: {
        name: "Chocolate Lover Birthday Box - Gold",
        price: 150,
    },
    silver: {
        name: "Chocolate Lover Birthday Box - Silver",
        price: 100,
    },
};
export var FriendsChannelState;
(function (FriendsChannelState) {
    FriendsChannelState[FriendsChannelState["Start"] = 0] = "Start";
    /** Transition to this state when Alex sends "Hey gang! Can you contribute the money now?" */
    FriendsChannelState[FriendsChannelState["AskForContribution"] = 1] = "AskForContribution";
    /** Transition to this state when "Alex paid $45 towards "Chocolate Lovers Birthday Box - Gold"" is sent */
    FriendsChannelState[FriendsChannelState["AlexPaid"] = 2] = "AlexPaid";
    /** Transition to this state when Alex sends "It comes to $45 each after taxes and fees." */
    FriendsChannelState[FriendsChannelState["AlexNotifiesShareAmount"] = 3] = "AlexNotifiesShareAmount";
    /** Transition to this state when "Robin paid $45 towards "Chocolate Lovers Birthday Box - Gold"" is sent */
    FriendsChannelState[FriendsChannelState["EveryonePaid"] = 4] = "EveryonePaid";
    /** Transition to this state when "Thanks team. Grace is going to be so surprised. See you at the party!" is sent */
    FriendsChannelState[FriendsChannelState["End"] = 5] = "End";
})(FriendsChannelState || (FriendsChannelState = {}));
export var SalesConciergeChannelState;
(function (SalesConciergeChannelState) {
    SalesConciergeChannelState[SalesConciergeChannelState["Start"] = 0] = "Start";
    SalesConciergeChannelState[SalesConciergeChannelState["AlexHasFriendWithBirthday"] = 1] = "AlexHasFriendWithBirthday";
    SalesConciergeChannelState[SalesConciergeChannelState["JadeAsksAboutAllergy"] = 2] = "JadeAsksAboutAllergy";
    SalesConciergeChannelState[SalesConciergeChannelState["AlexReplies"] = 3] = "AlexReplies";
    SalesConciergeChannelState[SalesConciergeChannelState["JadeSuggestsGifts"] = 4] = "JadeSuggestsGifts";
    SalesConciergeChannelState[SalesConciergeChannelState["AlexSelectsGift"] = 5] = "AlexSelectsGift";
    SalesConciergeChannelState[SalesConciergeChannelState["AlexOrdersGift"] = 6] = "AlexOrdersGift";
    SalesConciergeChannelState[SalesConciergeChannelState["AlexSplitsCost"] = 7] = "AlexSplitsCost";
    SalesConciergeChannelState[SalesConciergeChannelState["End"] = 8] = "End";
})(SalesConciergeChannelState || (SalesConciergeChannelState = {}));
export var DeliveryChannelState;
(function (DeliveryChannelState) {
    DeliveryChannelState[DeliveryChannelState["Start"] = 0] = "Start";
    DeliveryChannelState[DeliveryChannelState["AlexAsksETA"] = 1] = "AlexAsksETA";
    DeliveryChannelState[DeliveryChannelState["ETAShared"] = 2] = "ETAShared";
    DeliveryChannelState[DeliveryChannelState["AlexReactsToETA"] = 3] = "AlexReactsToETA";
    DeliveryChannelState[DeliveryChannelState["DriverAsksEntrance"] = 4] = "DriverAsksEntrance";
    DeliveryChannelState[DeliveryChannelState["AlexSaysWhichDoor"] = 5] = "AlexSaysWhichDoor";
    DeliveryChannelState[DeliveryChannelState["DeliveryCompleted"] = 6] = "DeliveryCompleted";
    DeliveryChannelState[DeliveryChannelState["End"] = 7] = "End";
})(DeliveryChannelState || (DeliveryChannelState = {}));
export var SupportChannelState;
(function (SupportChannelState) {
    SupportChannelState[SupportChannelState["Start"] = 0] = "Start";
    SupportChannelState[SupportChannelState["AlexAskQuestions"] = 1] = "AlexAskQuestions";
    SupportChannelState[SupportChannelState["BotAsksIfArticleHelped"] = 2] = "BotAsksIfArticleHelped";
    SupportChannelState[SupportChannelState["AlexRequestsLiveAgent"] = 3] = "AlexRequestsLiveAgent";
    SupportChannelState[SupportChannelState["JaimeGreets"] = 4] = "JaimeGreets";
    SupportChannelState[SupportChannelState["AlexSaysHeSplitCost"] = 5] = "AlexSaysHeSplitCost";
    SupportChannelState[SupportChannelState["JaimeAsksWhoSplitCost"] = 6] = "JaimeAsksWhoSplitCost";
    SupportChannelState[SupportChannelState["AlexAnswersWhoSplitCost"] = 7] = "AlexAnswersWhoSplitCost";
    SupportChannelState[SupportChannelState["JaimeAsksChannel"] = 8] = "JaimeAsksChannel";
    SupportChannelState[SupportChannelState["AlexAnswersChannel"] = 9] = "AlexAnswersChannel";
    SupportChannelState[SupportChannelState["JaimeConfirmsAmount"] = 10] = "JaimeConfirmsAmount";
    SupportChannelState[SupportChannelState["AlexConfirmsAmount"] = 11] = "AlexConfirmsAmount";
    SupportChannelState[SupportChannelState["JaimeAsksForWaitTime"] = 12] = "JaimeAsksForWaitTime";
    SupportChannelState[SupportChannelState["AlexWaits"] = 13] = "AlexWaits";
    SupportChannelState[SupportChannelState["JaimeSaysIssueResolved"] = 14] = "JaimeSaysIssueResolved";
    SupportChannelState[SupportChannelState["AlexSaysThanks"] = 15] = "AlexSaysThanks";
    SupportChannelState[SupportChannelState["BotAsksIfIssueResolved"] = 16] = "BotAsksIfIssueResolved";
    SupportChannelState[SupportChannelState["CSAT"] = 17] = "CSAT";
    SupportChannelState[SupportChannelState["ThankYouForFeedback"] = 18] = "ThankYouForFeedback";
    SupportChannelState[SupportChannelState["IssueNotResolved"] = 19] = "IssueNotResolved";
})(SupportChannelState || (SupportChannelState = {}));
export var PromotionsChannelState;
(function (PromotionsChannelState) {
    PromotionsChannelState[PromotionsChannelState["Start"] = 0] = "Start";
    PromotionsChannelState[PromotionsChannelState["Renewed"] = 1] = "Renewed";
    PromotionsChannelState[PromotionsChannelState["SharedOffer"] = 2] = "SharedOffer";
})(PromotionsChannelState || (PromotionsChannelState = {}));
export const friendsChannelSuggestedReplies = {
    [FriendsChannelState.Start]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.friends1,
            FriendsChannelState.AskForContribution,
        ],
    ],
    [FriendsChannelState.AskForContribution]: [],
    [FriendsChannelState.AlexPaid]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.friends2,
            FriendsChannelState.AlexNotifiesShareAmount,
        ],
    ],
    [FriendsChannelState.AlexNotifiesShareAmount]: [],
    [FriendsChannelState.EveryonePaid]: [
        [INTERACTIVE_CHAT_RESPONSES.new.friends3, FriendsChannelState.End],
    ],
    [FriendsChannelState.End]: [],
};
export const salesConciergeChannelSuggestedReplies = {
    [SalesConciergeChannelState.Start]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.salesConcierge1,
            SalesConciergeChannelState.AlexHasFriendWithBirthday,
        ],
    ],
    [SalesConciergeChannelState.AlexHasFriendWithBirthday]: [],
    [SalesConciergeChannelState.JadeAsksAboutAllergy]: [],
    [SalesConciergeChannelState.AlexReplies]: [],
    [SalesConciergeChannelState.JadeSuggestsGifts]: [],
    [SalesConciergeChannelState.AlexSelectsGift]: [],
    [SalesConciergeChannelState.AlexOrdersGift]: [],
    [SalesConciergeChannelState.AlexSplitsCost]: [],
    [SalesConciergeChannelState.End]: [],
};
export const deliveryChannelSuggestedReplies = {
    [DeliveryChannelState.Start]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.delivery1,
            DeliveryChannelState.AlexAsksETA,
        ],
    ],
    [DeliveryChannelState.AlexAsksETA]: [],
    [DeliveryChannelState.ETAShared]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.thumbsUp,
            DeliveryChannelState.AlexReactsToETA,
        ],
    ],
    [DeliveryChannelState.AlexReactsToETA]: [],
    [DeliveryChannelState.DriverAsksEntrance]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.delivery3,
            DeliveryChannelState.AlexSaysWhichDoor,
        ],
    ],
    [DeliveryChannelState.AlexSaysWhichDoor]: [],
    [DeliveryChannelState.DeliveryCompleted]: [],
    [DeliveryChannelState.End]: [],
};
const supportChannelSuggestedReplies = {
    [SupportChannelState.Start]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.support1,
            SupportChannelState.AlexAskQuestions,
        ],
    ],
    [SupportChannelState.AlexAskQuestions]: [],
    [SupportChannelState.BotAsksIfArticleHelped]: [
        [INTERACTIVE_CHAT_RESPONSES.new.support2, SupportChannelState.CSAT],
        [
            INTERACTIVE_CHAT_RESPONSES.new.support3,
            SupportChannelState.AlexRequestsLiveAgent,
        ],
    ],
    [SupportChannelState.AlexRequestsLiveAgent]: [],
    [SupportChannelState.JaimeGreets]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.support4,
            SupportChannelState.AlexSaysHeSplitCost,
        ],
    ],
    [SupportChannelState.AlexSaysHeSplitCost]: [],
    [SupportChannelState.JaimeAsksWhoSplitCost]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.support5,
            SupportChannelState.AlexAnswersWhoSplitCost,
        ],
    ],
    [SupportChannelState.AlexAnswersWhoSplitCost]: [],
    [SupportChannelState.JaimeAsksChannel]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.support6,
            SupportChannelState.AlexAnswersChannel,
        ],
    ],
    [SupportChannelState.AlexAnswersChannel]: [],
    [SupportChannelState.JaimeConfirmsAmount]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.yes,
            SupportChannelState.AlexConfirmsAmount,
        ],
    ],
    [SupportChannelState.AlexConfirmsAmount]: [],
    [SupportChannelState.JaimeAsksForWaitTime]: [
        [INTERACTIVE_CHAT_RESPONSES.new.great, SupportChannelState.AlexWaits],
    ],
    [SupportChannelState.AlexWaits]: [],
    [SupportChannelState.JaimeSaysIssueResolved]: [
        [
            INTERACTIVE_CHAT_RESPONSES.new.support7,
            SupportChannelState.AlexSaysThanks,
        ],
    ],
    [SupportChannelState.AlexSaysThanks]: [],
    [SupportChannelState.BotAsksIfIssueResolved]: [
        [INTERACTIVE_CHAT_RESPONSES.new.yes, SupportChannelState.CSAT],
        [INTERACTIVE_CHAT_RESPONSES.new.no, SupportChannelState.IssueNotResolved],
    ],
    [SupportChannelState.CSAT]: [],
    [SupportChannelState.ThankYouForFeedback]: [],
    [SupportChannelState.IssueNotResolved]: [],
};
export const channelSuggestedRepliesMap = {
    [channelCustomTypes.salesConcierge]: salesConciergeChannelSuggestedReplies,
    [channelCustomTypes.friends]: friendsChannelSuggestedReplies,
    [channelCustomTypes.delivery]: deliveryChannelSuggestedReplies,
    [channelCustomTypes.support]: supportChannelSuggestedReplies,
};
export const TAX_RATE = 6 / 5;
export const SCENARIO_VERSION = "0.0.13";
